// Back to the page after signing in. A page that finds no login sends the
// browser to /logout?next=<this page>, logout passes it on to the login page,
// and the login page goes there instead of the Dashboard. Only a path on this
// site is followed: never another host, never the login or logout pages.

const homeUrl = () => new URL(window.site.home, window.location.href);

// this page, as a path under site.home, with its query and hash
export const here = () => {
  const base = homeUrl().pathname.replace(/\/$/, '');
  const path = window.location.pathname;
  const rel = base && path.startsWith(base) ? path.slice(base.length) : path;
  return (rel || '/') + window.location.search + window.location.hash;
};

// the next= value when it is safe to follow, else null
export const safeNext = raw => {
  if (typeof raw !== 'string' || raw.length < 2 || raw.length > 2000) return null;
  if (raw[0] !== '/' || raw[1] === '/' || raw[1] === '\\') return null;
  if (/[\u0000-\u001f\\]/.test(raw)) return null;
  const path = raw.split(/[?#]/)[0].toLowerCase();
  if (/^\/(login|logout|demo)(\/|$)/.test(path)) return null;
  try {
    if (new URL(window.site.home + raw).origin !== homeUrl().origin) return null;
  } catch (e) {
    return null;
  }
  return raw;
};

// no login: sign in, then come back here
export const signInAndReturn = () => {
  window.location.href = window.site.home + '/logout?next=' + encodeURIComponent(here());
};
